const upsert = (selector, create, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(create.tag);
    Object.entries(create.attrs).forEach(([k, v]) => el.setAttribute(k, v));
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => el.setAttribute(k, v));
};

const meta = (key, value, attr = "name") =>
  upsert(`meta[${attr}="${key}"]`, { tag: "meta", attrs: { [attr]: key } }, { content: value || "" });

export function setHead({ title, description, canonical, image, type = "website", locale, robots = "index, follow", schema = [] }) {
  if (title) document.title = title;
  meta("description", description);
  meta("robots", robots);
  meta("og:title", title, "property");
  meta("og:description", description, "property");
  meta("og:type", type, "property");
  meta("og:url", canonical || window.location.href, "property");
  if (image) meta("og:image", image, "property");
  if (locale) meta("og:locale", locale, "property");
  meta("twitter:title", title);
  meta("twitter:description", description);
  if (image) meta("twitter:image", image);
  upsert('link[rel="canonical"]', { tag: "link", attrs: { rel: "canonical" } }, { href: canonical || window.location.href.split("#")[0] });
  let s = document.getElementById("page-schema");
  if (!s) {
    s = document.createElement("script");
    s.id = "page-schema";
    s.type = "application/ld+json";
    document.head.appendChild(s);
  }
  s.textContent = schema.length ? JSON.stringify(schema.length === 1 ? schema[0] : schema) : "";
}

export const parseSchema = (str) => {
  if (!str?.trim()) return [];
  try {
    const v = JSON.parse(str);
    return Array.isArray(v) ? v : [v];
  } catch {
    return [];
  }
};

export const prepareHtml = (html, perf, contacts) => {
  let out = html || "";
  if (contacts) out = out.replace(/\{\{(whatsapp|telegram|signal|login|join)\}\}/g, (_, k) => contacts[k] || "#");
  if (perf?.cdn_base_url) out = out.replace(/src="\/api\/files\//g, `src="${perf.cdn_base_url.replace(/\/$/, "")}/api/files/`);
  else out = out.replace(/src="\/api\/files\//g, `src="${process.env.REACT_APP_BACKEND_URL}/api/files/`);
  if (perf?.lazyload !== false) out = out.replace(/<img(?![^>]*loading=)/gi, '<img loading="lazy" decoding="async"');
  return out;
};
